import { render } from "./CreateAssignmentModal.vue?vue&type=template&id=6957a9d8&ts=true"
import script from "./CreateAssignmentModal.vue?vue&type=script&lang=ts"
export * from "./CreateAssignmentModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__